import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import EventIcon from '@material-ui/icons/Event';
import AssessmentIcon from '@material-ui/icons/Assessment';

import { makeStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import PaperMaterial from '@material-ui/core/Paper';

import Can from '~/contexts/Can';
import { AbilityContext } from '~/contexts/Can';
import CurrentUser from '~/contexts/CurrentUser';

import Socket from '~/tools/Socket';

import MedicalAppointmentsList from './MedicalAppointmentsList';
import ScheduledAppointmentsList from './ScheduledAppointmentsList';
import MedicalReport from './MedicalReport';
import notification from '~/assets/audios/notification.mp3';
const audio = new Audio(notification);

const useStyles = makeStyles(() => ({
  root: {
    padding: '15px 0px 0px 0px',
  },
}));

function Tabs() {
  const { t } = useTranslation();
  const classes = useStyles();
  const ability = useContext(AbilityContext);
  const { user } = useContext(CurrentUser);

  const [update, setUpdate] = useState(false);
  const [value, setValue] = React.useState('1');

  useEffect(() => {
    Socket.onConnect((ws) => {
      const _wsUser = ws.subscriptionOrSubscribe(`user:${user.uuid}`);
      _wsUser.on('message', ({ type }) => {
        if (type === 'newAppointment') {
          audio.play();
          setUpdate(true);
        }
      });
    });

    Socket.connect().catch(() => {});
  }, []);

  useEffect(() => {
    setUpdate(false);
  }, [update]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <TabContext value={value}>
      <PaperMaterial>
        <TabList
          variant="scrollable"
          textColor="secondary"
          onChange={handleChange}
        >
          <Tab
            icon={<LocalHospitalIcon />}
            label={t('medicalAppointments.tabs.appointments')}
            value="1"
            disabled={ability.cannot('list', 'MedicalAppointments')}
          />
          <Tab
            icon={<EventIcon />}
            label={t('medicalAppointments.tabs.scheduled_appointments')}
            value="2"
            disabled={ability.cannot('list', 'MedicalAppointments')}
          />
          <Tab
            icon={<AssessmentIcon />}
            label={t('medicalAppointments.tabs.appointments_reports')}
            value="3"
            disabled={ability.cannot('list', 'MedicalAppointments')}
          />
        </TabList>
      </PaperMaterial>

      <Can I="list" a="MedicalAppointments">
        <TabPanel className={classes.root} value="1">
          <MedicalAppointmentsList update={update} />
        </TabPanel>
      </Can>

      <Can I="list" a="MedicalAppointments">
        <TabPanel className={classes.root} value="2">
          <ScheduledAppointmentsList update={update} />
        </TabPanel>
      </Can>

      <Can I="list" a="MedicalAppointments">
        <TabPanel className={classes.root} value="3">
          <MedicalReport update={update} />
        </TabPanel>
      </Can>
    </TabContext>
  );
}

export default React.memo(Tabs);
